<template>
  <div class="financial-overview">
    <div class="panel sort-disable" id="p0">
      <div class="panel-heading">
        <span class="panel-title">Visão Geral</span>
        <span class="panel-controls">
          <select v-model="overviewMonth" class="financial-select">
            <option v-for="(month, i) in months" :value="i">{{ month }}</option>
          </select>
          <select v-model="overviewYear" class="financial-select">
            <option v-for="year in years">{{ year }}</option>
          </select>
        </span>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-4 br-r">
            <h5 class="mt5 ph10 pb5 br-b fw600">
              <i class="fa fa-arrow-down pr5 text-success"></i> Entradas
              <small class="pull-right fw600 text-primary">
                <a :href="hasFinancialFeature ? receivesPath : '#'">Ver detalhes</a>
              </small>
            </h5>
            <table class="table mbn">
              <tbody>
                <tr>
                  <td class="va-m fw600 text-muted">Recebido</td>
                  <td class="text-right fs15 fw600 tw-relative">
                    <BlurContent :show-blur="!hasFinancialFeature" :show-title="false" />
                    {{ dataSet.received | toCurrency }}
                  </td>
                </tr>
                <tr>
                  <td class="va-m fw600 text-muted">A receber</td>
                  <td class="text-right fs15 tw-relative">
                    <BlurContent :show-blur="!hasFinancialFeature" :show-title="false" />
                    {{ dataSet.to_receive | toCurrency }}
                  </td>
                </tr>
                <tr>
                  <td class="va-m fw600 text-muted">Total previsto</td>
                  <td class="text-right fs15 tw-relative">
                    <BlurContent :show-blur="!hasFinancialFeature" :show-title="false" />
                    {{ dataSet.receive_total | toCurrency }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4 br-r">
            <h5 class="mt5 ph10 pb5 br-b fw600">
              <i class="fa fa-arrow-up pr5 text-danger"></i> Saídas
              <small class="pull-right fw600 text-primary">
                <a :href="hasFinancialFeature ? paysPath : '#'">Ver detalhes</a>
              </small>
            </h5>
            <table class="table mbn">
              <tbody>
                <tr>
                  <td class="va-m fw600 text-muted">Pago</td>
                  <td class="text-right fs15 fw600 tw-relative">
                    <BlurContent :show-blur="!hasFinancialFeature" :show-title="false" />
                    {{ dataSet.paid | toCurrency }}
                  </td>
                </tr>
                <tr>
                  <td class="va-m fw600 text-muted">A pagar</td>
                  <td class="text-right fs15 tw-relative">
                    <BlurContent :show-blur="!hasFinancialFeature" :show-title="false" />
                    {{ dataSet.to_pay | toCurrency }}
                  </td>
                </tr>
                <tr>
                  <td class="va-m fw600 text-muted">Total previsto</td>
                  <td class="text-right fs15 tw-relative">
                    <BlurContent :show-blur="!hasFinancialFeature" :show-title="false" />
                    {{ dataSet.pay_total | toCurrency }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4 pln mvn15">
            <h5 class="ml5 mt20 ph10 pb5 br-b fw600">Resultados</h5>
            <table class="table mbn">
              <tbody>
                <tr>
                  <td class="va-m fw600 text-muted">Recebido - Pago</td>
                  <td
                    class="text-right fs15 fw600 tw-relative"
                    :class="[ isPositive(dataSet.received_minus_paid) ? 'text-success' : dataSet.received_minus_paid !== 0 ? 'text-danger' : '' ]"
                  >
                    <BlurContent :show-blur="!hasFinancialFeature" :show-title="false" />
                    {{ dataSet.received_minus_paid | toCurrency }}
                  </td>
                </tr>
                <tr>
                  <td class="va-m fw600 text-muted">A receber - a pagar</td>
                  <td
                    class="text-right fs15 tw-relative"
                    :class="[ isPositive(dataSet.to_receive_minus_to_pay) ? 'text-success' : dataSet.to_receive_minus_to_pay !== 0 ? 'text-danger' : '' ]"
                  >
                    <BlurContent :show-blur="!hasFinancialFeature" :show-title="false" />
                    {{ dataSet.to_receive_minus_to_pay | toCurrency }}
                  </td>
                </tr>
                <tr>
                  <td class="va-m fw600 text-muted">Total previsto</td>
                  <td
                    class="text-right fs15 tw-relative"
                    :class="[ isPositive(dataSet.receive_total_minus_pay_total) ? 'text-success' : dataSet.receive_total_minus_pay_total !== 0 ? 'text-danger' : '' ]"
                  >
                    <BlurContent :show-blur="!hasFinancialFeature" :show-title="false" />
                    {{ dataSet.receive_total_minus_pay_total | toCurrency }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import BlurContent from '../blur-content.vue'

export default {
  props: {
    companyCreatedAt: String,
    year: Number,
    hasFinancialFeature: Boolean
  },
  components: {
    BlurContent
  },
  data() {
    return {
      dataSet: {},
      overviewMonth: moment().month(),
      overviewYear: moment().year(),
      loaded: false,
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      years: []
    };
  },
  computed: {
    receivesPath: function() {
      const start = moment([this.overviewYear, this.overviewMonth]);
      const end = moment([this.overviewYear, this.overviewMonth]).endOf(
        "month"
      );

      return `/financial/cashflow?by_date%5Bstart%5D=${encodeURIComponent(start.format())}&by_date%5Bend%5D=${encodeURIComponent(end.format())}&debts=true`;
    },
    paysPath: function() {
      const start = moment([this.overviewYear, this.overviewMonth]);
      const end = moment([this.overviewYear, this.overviewMonth]).endOf(
        "month"
      );

      return `/financial/cashflow?by_date%5Bstart%5D=${encodeURIComponent(start.format())}&by_date%5Bend%5D=${encodeURIComponent(end.format())}&expenses=true`;
    }
  },
  mounted() {
    let years = [];
    for (
      let i = moment(this.companyCreatedAt).year();
      i <= moment().year();
      i++
    ) {
      years.push(i);
    }
    this.years = years;

    this.fetch();
  },
  watch: {
    overviewMonth: function() {
      this.fetch();
    },
    overviewYear: function() {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      axios
        .get(
          `/financial/overview?month=${this.overviewMonth + 1}&year=${
            this.overviewYear
          }`
        )
        .then(response => {
          this.dataSet = response.data;
        });
    },
    isPositive(number) {
      return number > 0;
    }
  },
  filters: {
    toCurrency: function(value) {
      if (value !== undefined) {
        return `R$ ${value.toLocaleString("pt-BR", {
          minimumFractionDigits: 2
        })}`;
      }
    }
  }
};
</script>
